import script from "./ProjectDetailDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectDetailDialog.vue?vue&type=script&setup=true&lang=js"

import "./ProjectDetailDialog.vue?vue&type=style&index=0&id=0960f4d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0960f4d8"]])

export default __exports__